import fetch from '../fetch'
import { message } from 'antd';

const insert = (domain) => {
    return fetch.post('leader/listen/insert' ,  domain)
    .then(res => {
        return res;
    })
}

const deleteFile = (ids) => {
    return fetch.post(`leader/listen/file/delete` ,  ids)
    .then(res => {
        if(res.code == 200){
            message.success("删除成功")
        }
    })
}


export default {
    insert ,
    upload : `${fetch.base}leader/listen/file` ,
    deleteFile 
}